/* eslint-disable */

import PersonalDetailsContent from 'components/PersonalDetails/components/content';
import GlobalContext from 'contexts';
import { useContext, useEffect, useState } from 'react';
import FormGroup from 'components/FormGroup';
import { fieldsEditMeasures } from 'components/Customers/componenets/Measures/utils';
import usePostData from 'hooks/usePostData';
import { calcBMI } from 'utils';

// import './styles.scss';
import useFetchData from 'hooks/useFetchData';

const EditMeeting = ({ meetingId, setOpenDrawer }) => {
  const { postData, res, error } = usePostData();
  let { currentMeetingDetails, currentCustomer } = useContext(GlobalContext);
  const [errFun, setErrFun] = useState();
  const { data: meetingData } = useFetchData(`measure/meeting/${meetingId}`);
  const [currentMeeting, setCurrentMeeting] = useState(null);
  const fieldsEditMeetingDetails = [
    { label: 'תאריך מפגש', name: 'startDate', format: 'date' },
    { label: 'סוג פגישה', name: 'categoryName' },
    { label: 'מטופל', name: 'clientFullName' }
  ];

  useEffect(() => {
    setCurrentMeeting(meetingData);
  }, [meetingData]);

  useEffect(() => {
    if (error)
      errFun?.set('apiError', {
        type: 'string',
        message: error.apiError
      });
    else if (res && res.affected === 1) {
      setCurrentMeeting(null);
      setOpenDrawer(false);
    }
  }, [res, error]);

  const handleUpdateMeeting = (data, setError) => {
    setErrFun({ set: setError });
    console.log('data', data);
    const measureData = {
      MuscleMass: parseInt(data.MuscleMass),
      muscleStrength: parseInt(data.muscleStrength),
      bloodPressureSys: parseInt(data.bloodPressureSys),
      bloodPressureDys: parseInt(data.bloodPressureDys),
      bmi: parseInt(calcBMI(currentMeetingDetails.height, data.whight)),
      fatPct: parseInt(data.fatPct),
      flexibilityIndex: parseInt(data.flexibilityIndex),
      heartBeatRate: parseInt(data.heartBeatRate),
      height: parseInt(data.height),
      whight: parseInt(data.whight),
      meetingSummery: data.meetingSummery,
      clientId: data.clientId,
      reporterId: data.reporterId,
      clientProductStageId: data.clientProductStageId,
      meetingId: data.meetingId
    };
    postData(`measure/${currentMeeting.id}`, measureData, 'post');
  };

  return (
    <div className="measures-edit">
      {currentMeeting && (
        <>
          <PersonalDetailsContent
            fields={fieldsEditMeetingDetails}
            data={currentMeetingDetails}
          />
          <div className="measures-area">
            <div className="measures-area-title">עדכון מדדים לפגישה</div>
            <FormGroup
              data={currentMeeting}
              fields={fieldsEditMeasures}
              onSubmit={handleUpdateMeeting}
            ></FormGroup>
          </div>
        </>
      )}
    </div>
  );
};

export default EditMeeting;

// CreateCustomer.propTypes = {
//     handleAddCustomerToOrg: PropTypes.func
// };
